"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var DragHandle =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(DragHandle, _React$Component);

  function DragHandle() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, DragHandle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(DragHandle)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onMouseDown", function (e) {
      _this.props.onMouseDown.call(null, e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onTouchStart", function (e) {
      _this.props.onTouchStart.call(null, e);
    });
    return _this;
  }

  (0, _createClass2.default)(DragHandle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var node = (0, _reactDom.findDOMNode)(this);
      if (!node) throw new Error('DragHandle missing element');
      node.addEventListener('mousedown', this._onMouseDown);
      node.addEventListener('touchstart', this._onTouchStart);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var node = (0, _reactDom.findDOMNode)(this);
      if (!node) throw new Error('DragHandle missing element');
      node.removeEventListener('mousedown', this._onMouseDown);
      node.removeEventListener('touchstart', this._onTouchStart);
    }
  }, {
    key: "render",
    value: function render() {
      // TODO In next major version remove the need for findDOMNode by using React.cloneElement here.
      // Update documentation to require that the element given to dragHandle is either
      // a native DOM element or forwards its props to one.
      return _react.default.Children.only(this.props.children);
    }
  }]);
  return DragHandle;
}(_react.default.Component);

exports.default = DragHandle;
module.exports = exports.default;
module.exports.default = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/react-draggable-list/js/DragHandle.js
// module id = 1018
// module chunks = 0